import React from "react";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { Title, showNotification } from "react-admin";
import { dataProvider } from "../../App";
import {
  ENABLE_2FA,
  VALIDATE_QR,
  DISABLE_2FA,
  STATUS_2FA
} from "../../misc/constants";
import TwoStepAuthenticationForm from "./TwoStepAuthenticationForm";
import ChangePasswordForm from "./ChangePasswordForm";
import RemoteSessionForm from "./RemoteSessionEnable";

const styles = {
  label: { width: "10em", display: "inline-block" },
  button: { margin: "1em" }
};

class SettingsEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = { key: null, token: null, qr_url: null, enabled: null };
    this.enable2FA = this.enable2FA.bind(this);
    this.disable2FA = this.disable2FA.bind(this);
    this.validate = this.validate.bind(this);
    this.handleChangeToken = this.handleChangeToken.bind(this);
  }

  componentDidMount() {
    dataProvider(STATUS_2FA).then(({ data }) => {
      this.setState({ ...data });
    });
  }

  enable2FA() {
    dataProvider(ENABLE_2FA).then(({ data }) => {
      this.setState({ ...data });
    });
  }

  disable2FA() {
    dataProvider(DISABLE_2FA).then(() => {
      this.setState({ key: null, token: null, qr_url: null, enabled: null });
    });
  }

  validate() {
    dataProvider(VALIDATE_QR, undefined, {
      key: this.state.key,
      token: this.state.token
    })
      .then(() => {
        this.setState({ enabled: true });
      })
      .catch(({ body }) => {
        this.props.showNotification(body.message, "warning");
      });
  }

  handleChangeToken(token) {
    this.setState({ token });
  }

  disabledView(classes) {
    return (
      <div>
        <Button
          variant="raised"
          onClick={this.enable2FA}
          className={classes.button}
        >
          Enable Two-Factor Authorization
        </Button>
        {this.state.qr_url && (
          <TwoStepAuthenticationForm
            {...this.state}
            validate={this.validate}
            onChange={this.handleChangeToken}
          />
        )}
      </div>
    );
  }

  enabledView(classes) {
    return (
      <div>
        <Button
          variant="raised"
          onClick={this.disable2FA}
          className={classes.button}
        >
          Disable Two-Factor Authorization
        </Button>
      </div>
    );
  }

  render() {
    const { classes } = this.props;
    return (
      <Card>
        <Title title="Settings" />
        <CardContent>
          <div className={classes.label}>Security Settings</div>
          {this.state.enabled
            ? this.enabledView(classes)
            : this.disabledView(classes)}
        </CardContent>
        <CardContent>
          <div className={classes.label}>Password Settings</div>
          <ChangePasswordForm />
        </CardContent>
        <CardContent>
          <div className={classes.label}>Remote Sessions</div>
          <RemoteSessionForm />
        </CardContent>
      </Card>
    );
  }
}

export default connect(
  null,
  {
    showNotification
  }
)(withStyles(styles)(SettingsEdit));
